var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selling-view"},_vm._l((_vm.sellings),function(goods,index){return _c('goodsItemView',{key:index,attrs:{"goods":goods}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }